export const REPORT_ERRORS = {
  empty_data: {
    type: 'empty_data',
    title: 'No results found.',
    message: "We couldn't find any results. Please make sure you've set your competitors or reach out to your Knotch associate.",
  },
};
